import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { useFont } from '../contexts/FontContext';
import { Target } from 'lucide-react';

interface OnboardingQuizProps {
  onComplete: (objective: string) => Promise<void>;
}

interface OnboardingQuizProps {
  onComplete: (objective: string) => void;
}

const objectives = [
  'réussir ma VAE d\'auxiliaire de puériculture',
  'augmenter mes connaissances',
  'réussir mon école d\'auxiliaire de puériculture',
  'me challenger',
  'préparer un changement de lieu d\'exercice'
];

export default function OnboardingQuiz({ onComplete }: OnboardingQuizProps) {
  const { theme } = useTheme();
  const { font } = useFont();
  const [selectedObjective, setSelectedObjective] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (selectedObjective) {
      try {
        await onComplete(selectedObjective);
        navigate('/dashboard');
      } catch (error) {
        console.error('Error setting objective:', error);
      }
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-lg max-w-xl w-full p-8" style={{ fontFamily: font.family }}>
        <div className="flex items-center justify-center mb-6">
          <div className={`w-12 h-12 rounded-full bg-${theme.secondary} flex items-center justify-center`}>
            <Target className={`h-6 w-6 text-${theme.text}`} />
          </div>
        </div>

        <h2 className="text-2xl font-bold text-center mb-2">Bienvenue !</h2>
        <p className="text-gray-600 text-center mb-8">
          Pour mieux vous accompagner, dites-nous quel est votre objectif principal :
        </p>

        <div className="space-y-3 mb-8">
          {objectives.map((objective) => (
            <button
              key={objective}
              onClick={() => setSelectedObjective(objective)}
              className={`
                w-full text-left p-4 rounded-lg border-2 transition-all duration-200
                ${selectedObjective === objective
                  ? `border-${theme.primary} bg-${theme.secondary}`
                  : 'border-gray-200 hover:border-gray-300'
                }
              `}
            >
              {objective}
            </button>
          ))}
        </div>

        <button
          onClick={handleSubmit}
          disabled={!selectedObjective}
          className={`
            w-full py-3 px-6 rounded-lg font-medium transition-all duration-200
            ${selectedObjective
              ? `bg-${theme.primary} text-white hover:opacity-90`
              : 'bg-gray-200 text-gray-400 cursor-not-allowed'
            }
          `}
        >
          Commencer
        </button>
      </div>
    </div>
  );
}